import OrderPickupTimeUpdatedAlertScreen from './OrderPickupTimeUpdatedAlertScreen';
import OrderPreparationReminderScreen from './OrderPreparationReminderScreen';
import OrdersPausedAlertScreen from './OrdersPausedAlertScreen';
import PendingOrderAlertScreen from './PendingOrderAlertScreen';

export default {
  OrderPickupTimeUpdatedAlertScreen,
  OrderPreparationReminderScreen,
  OrdersPausedAlertScreen,
  PendingOrderAlertScreen,
};
